// extracted by mini-css-extract-plugin
export default {"hero":"hero_hero__-6pS8","name":"hero_name__vyuhh","key":"hero_key__rQPjV","sub":"hero_sub__ZyKv8"};